<template>
  <page>
    <template slot='content'>
      <indicadores-resumo-preditiva-armazem></indicadores-resumo-preditiva-armazem>

      <hr>

      <os-preditiva-armazem></os-preditiva-armazem>

      <reloadPage></reloadPage>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsPreditivaArmazem from '@/components/OsPreditivaArmazem'
import IndicadoresResumoPreditivaArmazem from '@/components/IndicadoresResumoPreditivaArmazem'
import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsPreditivaArmazem,
    IndicadoresResumoPreditivaArmazem,
    reloadPage
  },

  computed:{
    mecanico() {
      let mecanicoOs = JSON.parse(localStorage.filial);
      if (mecanicoOs.atendeOs == 'S') {
        return false
      } else {
        return true
      }
    }
  },

  data () {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens de Serviço',
          active: true
        }
      ],
      showModalPreditivas: false
    }
  }
}
</script>
